import React from 'react';
export const InputContext = React.createContext(undefined);
//# sourceMappingURL=InputContext.js.map